export const SPREEDLY_ERROR = 'SpreedlyError';
export const TIMEKIT_BOOKING_ERROR_MESSAGE = 'Failed to create a booking on Timekit';

/**
 * `errorCode` values raised by visitor registration when a booking also creates visitors.
 * They arrive on `SerializableError.response.errorCode`, not on `key` — visitor registration
 * sends a plain-string `message` plus a separate top-level `errorCode`. See RES-1011.
 */
export enum VisitorRegistrationErrorsEnum {
  /** The visitor's email or phone number already belongs to another profile. */
  DUPLICATE_PROFILE = 'DUPLICATE_PROFILE',
}

/**
 * helix rejects a booking whose people (booker + guests) exceed the resource's capacity with a
 * 422 and a plain-string message, e.g. "Booking will exceed maximum capacity for resource <uuid>".
 * It carries no `key` or `errorCode`, so the message text is the only discriminator. See RES-1423.
 */
export const CAPACITY_EXCEEDED_ERROR_MESSAGE = 'exceed maximum capacity';
